// extracted by mini-css-extract-plugin
export default {"App":"App_App__tp6A0","App-logo":"App_App-logo__5lqUo","App-logo-spin":"App_App-logo-spin__QtOFA","App-header":"App_App-header__QY+w-","App-link":"App_App-link__uzoZ0"};